import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminUsersService } from '../admin-users.service';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { User } from 'src/app/core/interfaces/user';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserFormComponent } from '../user-form/user-form.component';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Utils } from 'src/app/core/resources/utils';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';

@Component({
  selector: 'app-admin-users-item',
  templateUrl: './admin-users-item.component.html',
  styleUrls: ['./admin-users-item.component.scss']
})
export class AdminUsersItemComponent {
  permission = Permission;
  @Input() user: User;
  @Input() activeTabType: 'user' | 'userClient' = 'user';
  @Output() emitToParent: EventEmitter<any> = new EventEmitter();


  constructor(
    private router: Router,
    public dialog: MatDialog,
    private utils: Utils,
    public permissionRole: PermissionRole
  ) { }

  /**
  * @returns {string} returns the prefix of each user.information.documentTypeId.
  * @description transforms the user's documentTypeId into a readable prefix.
  */
  get getDocumentType(): string {
    if (this.user.information) {
      switch (this.user.information.documentTypeId) {
        case '1':
          return "C.C: ";
        default:
          return this.user.information.documentTypeId;
      }
    }
  }


  selectUser(): void {
    if (!this.showDriverDetail) return;
    AdminUsersService.userSelected = this.user;
    if (this.activeTabType === 'userClient')
      this.router.navigate(['/administration/admin-users/detail-user-client-form/', this.user.information.document]);
    else
      this.router.navigate(['/administration/admin-users/detail/', this.user.information.document]);
  }

  /**
  * @returns {boolean} returns true if has the permission to read user's details, false in othercase.
  * @description checks if has permission to read users details.
  */
  get showDriverDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readDriverDetails);
  }

  /**
  * @returns {boolean} returns true if the user is a web user (userClient) in an inactive state.
  */
  get isInactiveWebUser(): boolean {
    return this.activeTabType === 'userClient' && !this.utils.getNestedValue(this.user, "state.active");
  }
}
